import { render, staticRenderFns } from "./ArticleSidebar.vue?vue&type=template&id=b2d5da70&scoped=true"
import script from "./ArticleSidebar.vue?vue&type=script&lang=js"
export * from "./ArticleSidebar.vue?vue&type=script&lang=js"
import style0 from "./ArticleSidebar.vue?vue&type=style&index=0&id=b2d5da70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d5da70",
  null
  
)

export default component.exports